// extracted by mini-css-extract-plugin
module.exports = {"icecream":"IceCream_icecream__1MUzW","cone":"IceCream_cone__3-iC4","cherry":"IceCream_cherry__1bKAy"};